import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
  selector: 'app-registration-unsaved-changes-dialog',
  templateUrl: './registration-unsaved-changes-dialog.component.html',
  styleUrls: ['./registration-unsaved-changes-dialog.component.css']
})
export class RegistrationUnsavedChangesDialogComponent implements OnDestroy {

    validFamily: boolean = false;
    hasErrors: boolean = false;

	constructor(
		private dialogBox: MatDialogRef<RegistrationUnsavedChangesDialogComponent>
	) {
    }

	ngOnDestroy() {
	}

	cancel() {
		this.dialogBox.close(-1);
	}

	continueWithoutSaving() {
		this.dialogBox.close(0);
	}

	saveFamily() {
		this.dialogBox.close(2);
	}

}
